<div class="max_width">
    <div class='impressum'>
        <h1>Impressum</h1>
        <h2>Angaben gemäß § 5 TMG:</h2>
        <p><br>Jan Horstmann</p>
        <h3>Postanschrift:</h3>
        <p>Kolkweg 41<br>Leer<br></p>
        <h3>Kontakt:</h3>
        <p>Telefon: 015223112545<br>E-Mail: kontakt&#64;jan-horstmann.eu</p>
        <p></p>
        <p><br></p>
        <p></p>
        <h2>Hinweise zur Website</h2>
        <p></p>
        <h2>Information gemäß § 36 VSBG</h2>
        <p>Gemäß § 36 VSBG (Verbraucherstreitbeilegungsgesetz – Gesetz über die alternative Streitbeilegung in
            Verbrauchersachen) erklärt der Betreiber dieser Website:</p>
        <p>Wir sind bereit, an Streitbeilegungsverfahren bei der folgenden Verbraucherschlichtungsstelle teilzunehmen:
        </p>
        <p></p>
        <p><em>Das Impressum wurde mit dem <a
                    href="https://www.activemind.de/datenschutz/generatoren/impressum/">Impressums-Generator der
                    activeMind AG</a> erstellt.</em></p>
    </div>
</div>